<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Dn Revenue Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select #selectedCountry class="form-control" placeholder="Country" (change)="changeCountry(selectedCountry.value)">
          <option *ngFor="let country of countryList | keyvalue" [value]="country.value" [selected]="country.value == selectedCountry">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Report Type</u></label>
        <select [(ngModel)]="filterable.reportType" class="form-control" placeholder="Report Type" (ngModelChange)="changeReportType($event)">
          <option *ngFor="let report of reportTypeList | keyvalue" [value]="report.key">{{report.value}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Tabs: {{totalItems}}<span  *ngIf="resultName != ''"  > - <span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>
  </div>
  <div class="col-2 ml-auto text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
  </div>
</div>
<div *ngIf="loaded">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mt-4">
    <li *ngFor="let dn of dnRevenues | keyvalue; index as i;" [ngbNavItem]="i">
      <a ngbNavLink>
        <h5>{{dn.key}}</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="table table-striped table-bordered mt-3 text-center" style="width:100%" *ngFor="let operatorMap of dn.value | keyvalue">
            <thead>
              <tr class="thead-dark">
                <th colspan="9">{{operatorMap.key}}</th>
              </tr>
              <tr>
                <th>ShortCode</th>
                <th>Keyword</th>
                <th>Affiliate</th>
                <th>Price</th>
                <th>Success DN</th>
                <th>Amount</th>
                <th>New Subscriber</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of operatorMap.value; index as i">
                <td>{{data.shortCode}}</td>
                <td>{{data.keyword}}</td>
                <td>{{data.affiliate}}</td>
                <td class="font-weight-bold text-uppercase" *ngIf="data.price == -1">Total</td>
                <td class="text-right" *ngIf="data.price != -1">{{data.price}}</td>
                <td class="text-right">{{data.dnSuccess}}</td>
                <td class="text-right">{{data.amount}}</td>
                <td class="text-right">{{data.newSubscriber}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2 mb-4"></div>
</div>

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
